import { call, put, takeLatest } from "redux-saga/effects";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";

import * as actionTypes from "Redux/Actions/actionTypes";
import PlaidVerificationGetRequest from "../../Communication/ApiClasses/PlaidVerificationGetRequest";

// worker
function* handleGetPlaidVerification(action) {
  yield put(doLoadingStart(`${actionTypes.GET_PLAID_VERIFICATION}_SAGA`));
  const plaidVerificationApi = new PlaidVerificationGetRequest(
    action.linkSessionId
  );
  try {
    const result = yield call(plaidVerificationApi.getData);
    yield call(action.callback, result);
  } catch (error) {
    yield call(action.callback, error.response);
  } finally {
    yield put(doLoadingFinish(`${actionTypes.GET_PLAID_VERIFICATION}_SAGA`));
  }
}

// watcher
export default function* getPlaidVerificationWatcherSaga() {
  yield takeLatest(
    actionTypes.GET_PLAID_VERIFICATION,
    handleGetPlaidVerification
  );
}
